__webpack_require__.p = "https://product-details.dev.core-artifacts.com/static/";